'use strict';
const raceAgainstTimeout = require('./race-against-timeout');
module.exports = function CiscoWebexScriptLoader({config, navigatorShim, ciscoWebexContainer} = {}) {
	if (!config || !navigatorShim || !ciscoWebexContainer) {
		throw new Error('invalid-args');
	}
	let scriptTag = false;
	const scriptsLoaded = function () {
			return !!(ciscoWebexContainer?.Webex?.Application);
		},
		isReady = function () {
			return scriptsLoaded();
		},
		ensureScripts = async function () {
			if (isReady()) {
				return ciscoWebexContainer;
			} else {
				let intervalId;
				const clearCheckInterval = () => {
						if (intervalId) {
							navigatorShim.clearInterval(intervalId);
						}
					},
					loadPromise = new Promise((resolve) => {
						const checkForCompletion = () => {
							if (isReady()) {
								resolve(ciscoWebexContainer);
							}
						};
						if (scriptTag) {
							scriptTag.remove();
							scriptTag = false;
						}
						//create script tag
						scriptTag = navigatorShim.loadScript(config.ciscoWebexScriptURL);
						navigatorShim.setInterval(checkForCompletion, 1000);
					});
				try {
					await raceAgainstTimeout(navigatorShim, loadPromise, config.scriptLoadingTimeout);
					clearCheckInterval();
					return ciscoWebexContainer;
				} catch (e) {
					clearCheckInterval();
					throw e;
				}
			}
		};
	Object.freeze(Object.assign(this, {ensureScripts}));
};
